import { RepeatCustomizationBottomSheetProps } from '@helpers/Models';
import { useState } from 'react';

export const RepeatCustomizationBottomSheet: React.FC<
  RepeatCustomizationBottomSheetProps
> = ({ onClose, speciesList, onConfirmSelection }) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const handleConfirm = () => {
    if (selectedIds !== null) {
      onConfirmSelection(selectedIds);
      onClose();
    } else {
      console.log('validation here');
    }
  };
  return (
    <div className="fixed z-10 inset-0 bg-black bg-opacity-40 flex justify-center items-end w-full h-full">
      <div className="bg-white rounded-t-2xl w-full p-6 shadow-lg transition-transform transform translate-y-0 max-h-[70vh] flex flex-col">
        <div className="flex justify-between items-center mb-4 ">
          <h1 className="font-bold text-lg">Repeat Customization For</h1>
          <div className="flex items-center gap-2">
            <div className="relative"></div>
            <button
              onClick={onClose}
              type="button"
              className="text-gray-600 hover:text-gray-900"
            >
              ✕
            </button>
          </div>
        </div>
        <div className="overflow-y-auto max-h-[60vh] space-y-3">
          {speciesList.map(
            ({ speciesData, currentCustomizingId, speciesNumber }) => {
              const isSelected = selectedIds.includes(currentCustomizingId);
              return (
                <div
                  key={currentCustomizingId}
                  className={`flex p-4 rounded-lg border shadow-lg w-full ${isSelected ? 'bg-tertiary border-primary' : 'bg-[#FFFEFA]'}`}
                  onClick={() =>
                    setSelectedIds(
                      (prev) =>
                        prev.includes(currentCustomizingId)
                          ? prev.filter((id) => id !== currentCustomizingId) // remove if already selected
                          : [...prev, currentCustomizingId], // add if not selected
                    )
                  }
                >
                  <div className="w-[85px] h-[80px] overflow-hidden border border-[#D4D4D4] rounded-md">
                    <img
                      alt={speciesData.name}
                      src={speciesData.imageUrl}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="ml-4 flex flex-col justify-center">
                    <h4 className="text-lg font-medium text-[#1C1B1F]">
                      {speciesData.name} - {speciesNumber}
                    </h4>
                  </div>
                </div>
              );
            },
          )}
          <button
            onClick={handleConfirm}
            type="button"
            className="w-full mt-4  bg-primary text-white rounded px-4 py-1 hover:bg-dark-primary"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};
